export default class formConfig {
  // 企业登记信息-详情
  static configList() {
    return [
      {
        title: "招标对项目负责人/总监要求",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "projectManagerList",
            value: "projectManagerList",
            class: "formList"
          },
        ]
      },
    ];
  }
}
